import { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import { getIn } from 'formik';
import moment from 'moment';

import isEmpty from 'Lib/utilities/isEmpty';

import { withPreviewContext } from './Context';

const mapStateToProps = state => ({
    account: state.app.account
});

class Field extends Component {
    onClick = () => {
        const { preview, pageIndex, index } = this.props;
        const field = preview.state.envelope.pages[pageIndex].fields[index];

        preview.setFieldInputValue(pageIndex, index, field.name);
    };

    refCallback = element => {
        if (element) {
            const { preview, pageIndex, index } = this.props;
            const field = preview.state.envelope.pages[pageIndex].fields[index];

            if (!field) {
                return;
            }

            const fieldInfo = preview.getAvailableFieldByName(field.name);

            if (fieldInfo.isInput == 1) {
                preview.addInputFieldElement(pageIndex, index, element);
            }
        }
    };

    renderSignature() {}

    buildApplicantFullName = () => {
        const firstName = getIn(this.props.form?.values, 'personalInfo.firstName');
        const lastName = getIn(this.props.form?.values, 'personalInfo.lastName');

        return `${firstName} ${lastName}`;
    };

    buildApplicationAddress = () => {
        const address = getIn(this.props.form?.values, 'applyingFor.address');
        const address2 = getIn(this.props.form?.values, 'applyingFor.address2');
        const city = getIn(this.props.form?.values, 'applyingFor.city');
        const stateID = getIn(this.props.form?.values, 'applyingFor.stateID');
        const postalCode = getIn(this.props.form?.values, 'applyingFor.postalCode');
        const countryID = getIn(this.props.form?.values, 'applyingFor.countryID');

        let fullAddress = address;
        if (!isEmpty(address2)) {
            fullAddress += ` ${address2}`;
        }
        fullAddress += ` ${city}, ${stateID} ${postalCode} ${countryID}`;

        return fullAddress;
    };

    buildApplicantCurrentAddress = () => {
        const address = getIn(this.props.form?.values, 'currentAddress.primaryAddress');
        const address2 = getIn(this.props.form?.values, 'currentAddress.primaryAddress2');
        const city = getIn(this.props.form?.values, 'currentAddress.primaryCity');
        const stateID = getIn(this.props.form?.values, 'currentAddress.primaryStateID');
        const postalCode = getIn(this.props.form?.values, 'currentAddress.primaryPostalCode');
        const countryID = getIn(this.props.form?.values, 'currentAddress.primaryCountryID');

        let fullAddress = address;
        if (!isEmpty(address2)) {
            fullAddress += ` ${address2}`;
        }
        fullAddress += ` ${city}, ${stateID} ${postalCode} ${countryID}`;

        return fullAddress;
    };

    render() {
        const { preview, pageIndex, index } = this.props;
        const { zoomFactor } = preview.state;

        const page = preview.state.envelope.pages[pageIndex];
        const field = preview.state.envelope.pages[pageIndex].fields[index];
        const fieldInfo = preview.getAvailableFieldByName(field.name);

        // Convert to percentages
        const left = (field.x / page.width) * 100;
        const top = (field.y / page.height) * 100;

        const style = {
            transformOrigin: 'left top',
            transform: `scale(${zoomFactor})`
        };

        let body = null;

        if (fieldInfo.isInput == 1) {
            const isActive = preview.state.currentInput?.pageIndex == pageIndex && preview.state.currentInput?.fieldIndex == index;
            const value = preview.getFieldInputValue(pageIndex, index);

            if (fieldInfo.inputType == 'signature') {
                if (value && value == 'signature') {
                    body = (
                        <div className="addendum-preview-field-panel">
                                <img
                                    src={`/api/public/screening/addendums/signature?signature=${this.props?.signature?.fullName}`}
                                    alt="Signed Via Rentvine"
                                    style={{
                                        width: 'auto',
                                        height: '40px'
                                    }}
                                />
                            </div>
                    );
                } else {
                    body = (
                        <button className={classNames('addendum-preview-field-panel is-input', { 'is-active': isActive })} style={style} onClick={this.onClick}>
                                <span className="addendum-preview-field-signature">
                                    Sign
                                    <br />
                                    <i className="fal fa-arrow-alt-to-bottom fa-2x"></i>
                                    <span className="sr-only">Sign Here</span>
                                </span>
                            </button>
                    );
                }
            } else if (fieldInfo.inputType == 'initials') {
                if (value && value == 'initials') {
                    body = (
                        <div className="addendum-preview-field-panel">
                                <img
                                    src={`/api/public/screening/addendums/initials?initials=${this.props?.signature?.initials}`}
                                    alt="Initialed Via Rentvine"
                                    style={{
                                        width: 'auto',
                                        height: '40px'
                                    }}
                                />
                            </div>
                    );
                } else {
                    body = (
                        <button className={classNames('addendum-preview-field-panel is-input', { 'is-active': isActive })} style={style} onClick={this.onClick}>
                                <span className="addendum-preview-field-signature">
                                    Initial
                                    <br />
                                    <i className="fal fa-arrow-alt-to-bottom fa-2x"></i>
                                    <span className="sr-only">Sign Here</span>
                                </span>
                            </button>
                    );
                }
            } else {
                body = (
                    <button className={classNames('addendum-preview-field-panel is-input', { 'is-active': isActive })} style={style} onClick={this.onClick}>
                            <span className="addendum-preview-field-signature">{fieldInfo.actionText}</span>
                        </button>
                );
            }
        } else {
            let value = '';

            if (fieldInfo.name == 'applicant.fullName') {
                value = this.buildApplicantFullName();
            } else if (fieldInfo.name == 'application.fullAddress') {
                value = this.buildApplicationAddress();
            } else if (fieldInfo.name == 'applicant.currentAddress') {
                value = this.buildApplicantCurrentAddress();
            } else if (fieldInfo.name == 'dateSigned') {
                value = moment(new Date()).format('MM/DD/YYYY');
            } else if (fieldInfo.name == 'account.name') {
                value = this.props.account.name;
            } else if (fieldInfo.name == 'account.companyName') {
                value = this.props.account.companyName;
            } else {
                value = fieldInfo.name;
            }

            body = (
                <div className="addendum-preview-field-panel" style={style}>
                        <img
                            src={`/api/public/screening/addendums/text?text=${value}`}
                            alt={fieldInfo.label}
                            style={{
                                width: 'auto',
                                height: '18px'
                            }}
                        />
                    </div>
            );
        }

        return (
            <div
                    style={{
                        display: 'inline-block',
                        position: 'absolute',
                        left: `${left}%`,
                        top: `${top}%`,
                        textAlign: 'left'
                    }}
                    tabIndex="0"
                    ref={this.refCallback}
                >
                    {body}
                </div>
        );
    }
}

export default withPreviewContext(connect(mapStateToProps)(Field));
